import Vue from 'vue'
import App from './App.vue'
import router from './router'
// 多语言
import VueI18n from 'vue-i18n'
// 导入样式重置文件
import './assets/css/reset.css'
// 导入全局样式
import './assets/css/global.css'
// 图标
import './assets/font/iconfont.css'

import globalMethod from '@/plugin'
Vue.use(globalMethod)

// 导入并配置axios
import axios from 'axios'

// 导入vant框架
import Vant from 'vant'
import 'vant/lib/index.css'

// import Language from './lang/lang.json'
// 修改代理，四个websocket地址[index,trade/index,trade/contact,trade/contact_list]
// axios.defaults.baseURL = 'http://weipan.cs389.bio/'
// axios.defaults.baseURL = 'https://gica.bio/'
// axios.defaults.baseURL = '/api'
// axios.defaults.baseURL = 'https://cs366.org'
axios.defaults.baseURL = configMore.BaseUrl
if (process.env.NODE_ENV === 'production') {
    // axios.defaults.baseURL = 'https://cs366.org'
    axios.defaults.baseURL = configMore.BaseUrl
}
// 请求拦截
axios.interceptors.request.use((config) => {
    config.headers.Authorization = window.localStorage.getItem('token')
    return config
})
// 响应拦截
// axios.interceptors.response.use(response => {
//   if (response.data.code === 401) {
//     window.localStorage.removeItem('token')
//     router.push('/login')
//     return false
//   } else {
//     return response
//   }
// })
// 将axios挂载为全局方法$http
Vue.prototype.$http = axios
// Vue.prototype.wsurl = 'wss://cs366.org/'
Vue.prototype.wsurl = configMore.BaseUrlWss
// Vue.prototype.wsurl = 'http://weipan.cs389.bio/'
// Vue.prototype.wsurl = 'wss://gica.bio/'
// 全局函数
Vue.prototype.getlang = (msg, lang) => {
    lang = lang || 'en'
    try {
        let data = require(`./lang/${lang}.json`)

        // 检查是否有完全匹配的翻译
        if (data[msg]) {
            return data[msg]
        }

        // 处理动态消息模式
        for (let key in data) {
            if (msg.startsWith(key) && key !== msg) {
                const dynamicPart = msg.substring(key.length)
                return data[key] + dynamicPart
            }
        }

        return msg // 如果找不到翻译则返回原消息
    } catch (e) {
        console.error(`Failed to load language file for ${lang}:`, e)
        return msg // 出错时返回原消息
    }
}
// 全局时间过滤器
Vue.filter('dateformat', function (time) {
    const dt = new Date(parseInt(time) * 1000)
    const y = dt.getFullYear()
    const m = (dt.getMonth() + 1 + '').padStart(2, '0')
    const d = (dt.getDate() + '').padStart(2, '0')
    const hh = (dt.getHours() + '').padStart(2, '0')
    const mm = (dt.getMinutes() + '').padStart(2, '0')
    const ss = (dt.getSeconds() + '').padStart(2, '0')
    return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
})
// 多语言
// 语言包
Vue.prototype.$languages = [
    { text: '中文', value: 'zh' },
    { text: 'English', value: 'en' },
    { text: 'русский язык', value: 'ru' },
    { text: 'Français', value: 'fr' },
    { text: 'Español', value: 'es' },
    { text: 'Italiano', value: 'it' },
    { text: 'Português', value: 'pt' },
]
Vue.use(VueI18n)
const zh = require('./lang/zh.json')
const en = require('./lang/en.json')
const ru = require('./lang/ru.json')
const es = require('./lang/es.json')
const fr = require('./lang/fr.json')
const it = require('./lang/it.json')
const pt = require('./lang/pt.json')
const i18n = new VueI18n({
    locale: localStorage.getItem('lang') || 'en',
    messages: {
        zh: {
            ...zh,
        }, // 中文语言包
        en: {
            ...en,
        }, // 英文语言包
        ru: {
            ...ru,
        },
        it: {
            ...it,
        },
        fr: {
            ...fr,
        },
        es: {
            ...es,
        },
        pt: {
            ...pt,
        }, // 葡萄牙语语言包
    },
})
// 全局配置初始化函数
async function initAppConfig() {
    try {
        const response = await axios.get('/home/index/getconfig')
        if (response.data && response.data.code === 200) {
            const config = response.data.data
            Vue.prototype.$appConfig = config
            localStorage.setItem('app_config', JSON.stringify(config))
            // 动态设置浏览器图标
            const link =
                document.querySelector("link[rel*='icon']") ||
                document.createElement('link')
            link.type = 'image/x-icon'
            link.rel = 'shortcut icon'
            link.href = config.icon || '/favicon.ico'
            document.getElementsByTagName('head')[0].appendChild(link)

            return config
        }
    } catch (error) {}

    const defaultConfig = {
        register_mode: '',
        sms_isopend: 0,
        email_isopend: 0,
        is_invite_register: 0,
    }
    Vue.prototype.$appConfig = defaultConfig
    return defaultConfig
}

// Vue.prototype.$Local = Locals
// vant框架
Vue.use(Vant)
Vue.config.productionTip = false

// 初始化应用配置后再创建Vue实例
initAppConfig().then(() => {
    new Vue({
        i18n,
        router,
        render: (h) => h(App),
    }).$mount('#app')
})
